// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c11470ef","885":"3977cef0","977":"930ccdaf"}[chunkId] + ".chunk.js";
};